export enum KingClubAssets {
  ThroneBadgeWhite = '/assets/images/icons/club/throne-badge.svg',
  JumpingWoman = '/assets/images/icons/club/jumping-woman.webp',
  ProgramTxt = '/assets/images/icons/club/program.svg',
  RewTxt = '/assets/images/icons/club/rew.svg',
  ArdTxt = '/assets/images/icons/club/ard.svg',
  Avatars = '/assets/images/icons/club/avatars.webp',
  BgBlueDesktop = '/assets/images/icons/club/bg-blue-desktop.png',
  BgBlueMobile = '/assets/images/icons/club/bg-blue-mobile.png',
  BgGreyDesktop = '/assets/images/icons/club/bg-grey-desktop.png',
  BgGreyMobile = '/assets/images/icons/club/bg-grey-mobile.png',
  Rewards = '/assets/images/icons/club/rewards.png',
  BronzeBadge = '/assets/images/icons/club/bronze-badge.svg',
  BronzeBadge2 = '/assets/images/icons/club/bronze-badge2.svg',
  SilverBadge = '/assets/images/icons/club/silver-badge.svg',
  SilverBadge2 = '/assets/images/icons/club/silver-badge2.svg',
  GoldBadge = '/assets/images/icons/club/gold-badge.svg',
  GoldBadge2 = '/assets/images/icons/club/gold-badge2.svg',
  PlatinumBadge = '/assets/images/icons/club/platinium-badge.svg',
  PlatinumBadge2 = '/assets/images/icons/club/platinium-badge2.svg',
  DiamondBadge = '/assets/images/icons/club/diamond-badge.svg',
  DiamondBadge2 = '/assets/images/icons/club/diamond-badge2.svg',
  BannerDesktop = '/assets/images/icons/club/banner.png',
  BannerMobile = '/assets/images/icons/club/banner-mobile.png',
  BenefitsBgWhite = '/assets/images/icons/club/benefits-bg-white.png',
  BenefitsBgBlue = '/assets/images/icons/club/benefits-bg-blue.png',
  BenefitsBgMobile = '/assets/images/icons/club/benefits-bg-mobile.png',
  Shop = '/assets/images/icons/club/shop.svg',
  EarnDiscount = '/assets/images/icons/club/earn.svg',
  Redeem = '/assets/images/icons/club/redeem.svg',
  QuoteGrey = '/assets/images/icons/club/quote-grey.svg',
  InstagramLogo = '/assets/images/icons/club/instagram-logo.svg',
  FacebookLogo = '/assets/images/icons/club/facebook-logo.svg',
  XLogo = '/assets/images/icons/club/x-logo.svg',
  LinkedinLogo = '/assets/images/icons/club/linkedin-logo.svg',
  TelegramLogo = '/assets/images/icons/club/telegram-logo.svg',
  KingLogoWhite = '/assets/images/icons/club/king-logo-white.svg',
  KingLogoBlue = '/assets/images/icons/club/king-logo-blue.svg',
  Avatar1 = '/assets/images/icons/club/avatar1.png',
  Avatar2 = '/assets/images/icons/club/avatar2.png',
  Avatar3 = '/assets/images/icons/club/avatar3.png',
  Avatar4 = '/assets/images/icons/club/avatar4.png',
  ChevronUpBlue = '/assets/images/icons/club/chevron-up-grey.svg',
  ChevronDownGrey = '/assets/images/icons/club/chevron-down-grey.svg',
  Percentage = '/assets/images/icons/club/percentage.svg',
  WarningGray = '/assets/images/icons/club/warning-gray.svg',
  TwoDots = '/assets/images/icons/two-dots.svg',
  Done = '/assets/images/icons/club/done.svg',
  Upcoming = '/assets/images/icons/club/upcoming.svg'
}

export enum Icons {
  LightMode = '/assets/images/icons/light-mode.svg',
  LightModeActive = '/assets/images/icons/light-mode-active.svg',
  DarkMode = '/assets/images/icons/dark-mode.svg',
  DarkModeActive = '/assets/images/icons/dark-mode-active.svg',

  PageNext = '/assets/images/icons/paginator/next-active.svg',
  PageLast = '/assets/images/icons/paginator/last-active.svg',
  PagePreviousDisabled = '/assets/images/icons/paginator/previous-disabled.svg',
  PageFirstDisabled = '/assets/images/icons/paginator/first-disabled.svg',

  PageEllipsis = '/assets/images/icons/paginator/ellipsis.svg'
}
